var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2365_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.5C39 22.1413 37.1563 26.5925 33.8744 29.8744C30.5925 33.1563 26.1413 35 21.5 35C16.8587 35 12.4075 33.1563 9.12563 29.8744C5.84375 26.5925 4 22.1413 4 17.5C4 12.8587 5.84375 8.40752 9.12563 5.12563C12.4075 1.84375 16.8587 0 21.5 0C26.1413 0 30.5925 1.84375 33.8744 5.12563C37.1563 8.40752 39 12.8587 39 17.5V17.5ZM18.8531 11.1409C18.6896 11.0245 18.4971 10.9553 18.2969 10.941C18.0966 10.9266 17.8963 10.9677 17.7178 11.0596C17.5394 11.1516 17.3896 11.2909 17.2851 11.4622C17.1805 11.6336 17.1251 11.8305 17.125 12.0312V22.9688C17.1251 23.1695 17.1805 23.3664 17.2851 23.5378C17.3896 23.7091 17.5394 23.8484 17.7178 23.9404C17.8963 24.0323 18.0966 24.0734 18.2969 24.059C18.4971 24.0447 18.6896 23.9755 18.8531 23.8591L26.5094 18.3903C26.6512 18.2891 26.7667 18.1556 26.8465 18.0007C26.9262 17.8458 26.9678 17.6742 26.9678 17.5C26.9678 17.3258 26.9262 17.1542 26.8465 16.9993C26.7667 16.8444 26.6512 16.7109 26.5094 16.6097L18.8531 11.1409V11.1409Z",
    fill: "red"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2365_5",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0 0.466667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2365_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2365_5",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayblue);
export default __webpack_public_path__ + "static/media/playblue.644813bd44097f70bbfb9812b3ad35e1.svg";
export { ForwardRef as ReactComponent };